/**
 * @aurora-catalyst-generated
 * @source cliter/packages
 *
 * Composed from the installed package manifests on every render. Register project entries in
 * project.composition.ts instead of editing this file.
 */
import type { EnvironmentProviders } from '@angular/core';
import { iamWidgetProviders } from './domains/admin/apps/iam/widgets/iam.widgets';
import { oAuthWidgetProviders } from './domains/admin/apps/o-auth/widgets/o-auth.widgets';
import { queueManagerWidgetProviders } from './domains/admin/apps/queue-manager/widgets/queue-manager.widgets';
import { projectWidgetProviders } from './project.composition';
/**
 * Composition-root aggregator of every bounded context's Aurora widget providers.
 *
 * Widgets are a FRAMEWORK primitive: the registry token and `AuroraWidgetDef` contract live in
 * `@aurora`, so this aggregator is named for the framework (`aurora-widget`), not for the dashboard.
 * `aurora.provider.ts` registers the whole set with a single `...auroraWidgetProviders`.
 *
 * It lives at the app root because aggregating across BCs is a composition concern: inside a BC it
 * would couple that BC to the others, inside `@aurora` it would invert the framework->app
 * dependency (HR-PORTS-001).
 */
export const auroraWidgetProviders: EnvironmentProviders[] = [
  ...queueManagerWidgetProviders,
  ...iamWidgetProviders,
  ...oAuthWidgetProviders,
  ...projectWidgetProviders,
];
